import { useState } from 'react';
import { admin, type CostByModel } from '../../lib/api';
import { useApi } from '../../hooks/useApi';
import { DataTable, Tabs, type Column } from '../../components/ui';
import { useAdminT } from './adminI18n';

export default function AdminCostPage() {
  const t = useAdminT();
  const [days, setDays] = useState(30);
  const c = useApi(() => admin.cost(days), [days]);
  const data = c.status === 'success' ? c.data : null;

  const maxDay = data ? Math.max(1, ...data.by_day.map((d) => d.cost_usd)) : 1;

  const columns: Column<CostByModel>[] = [
    { key: 'model', header: t('col.name'), render: (r) => r.model, mono: true },
    { key: 'cost_usd', header: t('cost.total'), align: 'right', mono: true,
      render: (r) => `$${r.cost_usd.toFixed(2)}` },
    { key: 'calls', header: t('cost.calls'), align: 'right', mono: true, render: (r) => String(r.calls) },
    { key: 'tokens', header: 'in/out', align: 'right', mono: true,
      render: (r) => `${r.input_tokens}/${r.output_tokens}` },
  ];

  return (
    <div className="admin-page">
      <header className="admin-page__head">
        <h1>{t('cost.title')}</h1>
        <p className="admin-page__sub">{t('cost.subtitle')}</p>
      </header>

      <div className="admin-toolbar">
        <Tabs
          value={String(days)}
          onChange={(v) => setDays(Number(v))}
          items={[
            { key: '7', label: t('cost.range7') },
            { key: '30', label: t('cost.range30') },
            { key: '90', label: t('cost.range90') },
          ]}
        />
      </div>

      <div className="admin-stats">
        <div className="admin-stat is-accent">
          <span className="admin-stat__label">{t('cost.total')}</span>
          <span className="admin-stat__value">{data ? `$${data.total_usd.toFixed(2)}` : '—'}</span>
        </div>
        <div className="admin-stat">
          <span className="admin-stat__label">{t('cost.calls')}</span>
          <span className="admin-stat__value">{data ? data.total_calls : '—'}</span>
        </div>
      </div>

      <section className="admin-section">
        <div className="sec-head"><h2>{t('cost.byModel')}</h2></div>
        <DataTable columns={columns} rows={data?.by_model ?? []} rowKey={(r) => r.model}
          loading={c.status === 'loading'} empty={t('emptyGeneric')} />
      </section>

      {data && data.by_day.length > 0 && (
        <section className="admin-section">
          <div className="sec-head"><h2>{t('cost.byDay')}</h2></div>
          <div className="admin-bars">
            {data.by_day.map((d) => (
              <div key={d.day} className="admin-bar" title={`${d.day}: $${d.cost_usd.toFixed(2)}`}>
                <div className="admin-bar__fill" style={{ height: `${(d.cost_usd / maxDay) * 100}%` }} />
                <span className="admin-bar__label">{d.day.slice(5)}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
